// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__RBtNK","isSelected":"Button_isSelected__-6JYv"};